<template>
  <basic-container>
    <div class="avue-crud">
      <el-row :hidden="!search" style="padding: 6px 18px">
        <!-- 查询模块 -->
        <el-form :inline="true" :model="query">
          <el-form-item :label="Lang.label.paramName">
            <el-input v-model="query.paramName" :placeholder="Lang.tips.plzInputParamName"></el-input>
          </el-form-item>
          <el-form-item :label="Lang.label.paramKey">
            <el-input v-model="query.paramKey" :placeholder="Lang.tips.plzInputParamKey"></el-input>
          </el-form-item>
          <!-- 查询按钮 -->
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchChange">{{ Lang.btn.search }}</el-button>
            <el-button icon="el-icon-delete" @click="searchReset()">{{ Lang.btn.empty }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <div class="avue-crud__header">
          <!-- 头部左侧按钮模块 -->
          <div class="avue-crud__left">
            <el-button
              v-if="permissionObj.add" 
              type="primary"
              icon="el-icon-plus"
              @click="handleAdd"
              >{{ Lang.btn.addNew }}
            </el-button>
            <el-button
              v-if="permissionObj.delete" 
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete"
              plain
              >{{ Lang.btn.delete }}
            </el-button>
          </div>
          <!-- 头部右侧按钮模块 -->
          <div class="avue-crud__right">
            <el-button icon="el-icon-refresh" @click="searchChange" circle></el-button>
            <el-button icon="el-icon-search" @click="searchHide" circle></el-button>
          </div>
        </div>
      </el-row>
      <el-row>
        <!-- 列表模块 -->
        <el-table
          ref="table"
          v-loading="loading"
          @selection-change="selectionChange"
          :data="data"
          :height="height"
          style="width: 100%"
          :border="option.border"
        >
          <el-table-column
            type="selection"
            v-if="option.selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column type="expand" v-if="option.expand" align="center"></el-table-column>
          <el-table-column v-if="option.index" label="#" type="index" width="50" align="center">
          </el-table-column>
          <template v-for="(item, index) in option.column">
            <!-- table字段 -->
            <el-table-column
              v-if="item.hide !== true"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :key="index"
            >
            </el-table-column>
          </template>
          
          <!-- 操作栏模块 -->
          <el-table-column prop="menu" :label="Lang.label.operation" :width="116" align="center">
            <!-- 操作菜单按钮 -->
            <template #="scope">
              <div class="operation-btns">
                <CompIconButton :auth="permissionObj" type="view" @click="handleView(scope.row)" > </CompIconButton>
                <CompIconButton :auth="permissionObj" type="edit" @click="handleEdit(scope.row)" > </CompIconButton>
                <CompIconButton :auth="permissionObj" type="delete" :divider="false" @click="handleDel(scope.row)" > </CompIconButton>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <div class="avue-crud__pagination" style="width: 100%">
          <!-- 分页模块 -->
          <el-pagination
            align="right"
            background
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page="page.currentPage"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </el-row>
      <!-- 表单模块 -->
      <el-dialog
        :title="title"
        v-model="box"
        width="50%"
        :before-close="beforeClose"
        append-to-body
      >
        <el-form :disabled="view" ref="form" :model="form" label-width="80px">
          <!-- 表单字段 -->
          <el-form-item :label="Lang.label.paramName" prop="paramName">
            <el-input v-model="form.paramName" :placeholder="Lang.tips.plzInputParamName" />
          </el-form-item>
          <el-form-item :label="Lang.label.paramKey" prop="paramKey">
            <el-input v-model="form.paramKey" :placeholder="Lang.tips.plzInputParamKey" />
          </el-form-item>
          <el-form-item :label="Lang.label.paramValue" prop="paramValue">
            <el-input v-model="form.paramValue" :placeholder="Lang.tips.plzInputParamValue" />
          </el-form-item>
          <el-form-item :label="Lang.label.remark" prop="remark">
            <el-input v-model="form.remark" :placeholder="Lang.tips.plzInputRemark" />
          </el-form-item>
        </el-form>
        <!-- 表单按钮 -->
        <template #footer>
          <span v-if="!view" class="dialog-footer">
            <el-button type="primary" icon="el-icon-circle-check" @click="handleSubmit"
              >{{ Lang.btn.submit }}</el-button
            >
            <el-button icon="el-icon-circle-close" @click="box = false">{{ Lang.btn.cancel }}</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </basic-container>
</template>

<script>
import { getList, getDetail, add, update, remove } from '@/api/system/param';
import { Lang } from '@/lang/lang';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      height: 0,
      // 弹框标题
      title: '',
      // 是否展示弹框
      box: false,
      // 是否显示查询
      search: true,
      // 加载中
      loading: true,
      // 是否为查看模式
      view: false,
      // 查询信息
      query: {},
      // 分页信息
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 40,
      },
      // 表单数据
      form: {},
      // 选择行
      selectionList: [],
      // 表单配置
      option: {
        height: 'auto',
        calcHeight: 104,
        expand: false,
        index: true,
        border: true,
        selection: true,
        column: [
          {
            label: this.Lang.label.paramName,
            prop: 'paramName',
          },
          {
            label: this.Lang.label.paramKey,
            prop: 'paramKey',
          },
          {
            label: this.Lang.label.paramValue,
            prop: 'paramValue',
          },
          {
            label: this.Lang.label.remark,
            prop: 'remark',
          },
        ],
      },
      // 表单列表
      data: [],
    };
  },
  mounted() {
    this.init();
    this.onLoad(this.page);
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('菜单页面权限', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    init() {
      this.height = this.setPx(document.body.clientHeight - 340);
    },
    searchHide() {
      this.search = !this.search;
    },
    searchChange() {
      this.onLoad(this.page);
    },
    searchReset() {
      this.query = {};
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    handleSubmit() {
      if (!this.form.id) {
        add(this.form).then(() => {
          this.box = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
      } else {
        update(this.form).then(() => {
          this.box = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
      }
    },
    handleAdd() {
      this.title = this.Lang.btn.addNew;
      this.form = {};
      this.box = true;
    },
    handleEdit(row) {
      this.title = this.Lang.btn.edit;
      this.box = true;
      getDetail(row.id).then(res => {
        this.form = res.data.data;
      });
    },
    handleView(row) {
      this.title = this.Lang.btn.view;
      this.view = true;
      this.box = true;
      getDetail(row.id).then(res => {
        this.form = res.data.data;
      });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.selectionClear();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    handleDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    beforeClose(done) {
      done();
      this.form = {};
      this.view = false;
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.table.clearSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad(this.page);
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad(this.page);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>
